import React from 'react';
import styled from 'styled-components';
import ProjectCard, { ProjectCardProps } from '../Projects/ProjectCard/ProjectCard';

const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Heading = styled.h2`
  margin: 0;
  font-size: 40px;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 700;
  display: inline-block;
  width: fit-content;
  background: linear-gradient(45deg, #34d399, #06b6d4);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;

  body.dark & {
    background: linear-gradient(45deg, #f472b6, #fb923c);
    background-clip: text;
    -webkit-background-clip: text;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const MISC_ITEMS: ProjectCardProps[] = [
  {
    id: 'metaball-grid',
    title: 'Metaball Grid',
    description: 'A CSS grid with metaball-style selection effects.',
    tags: ['CSS', 'Interactive'],
  },
];

const Misc: React.FC = () => (
  <Container>
    <Heading>Misc</Heading>
    <Grid>
      {MISC_ITEMS.map(item => <ProjectCard key={item.id} {...item} />)}
    </Grid>
  </Container>
);

export default Misc;
